module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4r5n1n2n-bfc87f9f6dae2d991a7d1d3d8acdc066.svg";